<template>
  <div>
    <Navbar v-show="routemeta.navbar" />
    <Breadcrumb v-show="routemeta.navbar" />
    <div class="container-xl">
      <div class="border-0 text-container-wider">
        <h1 class="text-primary">
          Hi {{ this.$store.state.user.first_name }} {{ this.$store.state.user.family_name }}!
        </h1>
        <div class="row mx-0 px-0">
          <div class="mx-0 px-0 col-12 col-lg-8">
            Welcome to the GDQ Learning Hub.
            <p class="mx-0 px-0 mt-4">
              Here you will find all courses offered by GDQ Associates. You can register for courses, follow the progress in your learning journey or review materials from completed courses.
            </p>
          </div>
          <div class="mx-0 px-0 col-12 col-lg-4 text-end text-top">
            <button type="button" class="btn btn-primary">Contact your tutor</button>
          </div>
        </div>
        <h3
          class="pt-4 mt-4"
          style="border-top: 1px solid black"
        >
          Courses
        </h3>
        <BaseTable
          class="mx-0 px-0 mb-4"
          :items="courses"
          :busy="loading"
          :fields="coursesColumns"
          :per-page="coursesPerPage"
        >
          <template v-slot:cell(location)="data">
            {{ data.item.course_location }}
          </template>
          <template v-slot:cell(actions)="data">
            <div class="w-100">
              <BaseDropdown right class="w-100">
                <template #button-content>
                  <i class="fa-solid fa-ellipsis"></i>
                </template>
                <router-link
                  v-if="data.item.status === 'Not started'"
                  class="dropdown-item"
                  :to="`/elearningcourse/${data.item.id}/0`"
                >
                  Start
                </router-link>
                <span
                  v-if="data.item.status === 'Available'"
                  class="dropdown-item disabled text-muted"
                >
                  Apply
                </span>
                <router-link
                  v-if="data.item.status === 'In progress'"
                  class="dropdown-item"
                  :to="`/elearningcourse/${data.item.id}/0`"
                >
                  Continue
                </router-link>
                <router-link
                  v-if="data.item.status === 'Completed'"
                  class="dropdown-item"
                  :to="`/elearningcourse/${data.item.id}/0`"
                >
                  Continue
                </router-link>
              </BaseDropdown>
            </div>
          </template>
        </BaseTable>
        <h3
          class="pt-4 mt-4"
          style="border-top: 1px solid black"
        >
          My certificates
        </h3>
        <BaseTable
          class="mx-0 px-0"
          :items="certificates"
          :fields="certificatesColumns"
          :per-page="certificatesPerPage"
        />
      </div>
    </div>
  </div>
</template>
<script>

import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'
import BaseTable from './base/BaseTable.vue'
import BaseDropdown from './base/BaseDropdown.vue'

export default {
  name: 'LearningHub',
  components: {
    Navbar,
    Breadcrumb,
    BaseTable,
    BaseDropdown
  },
  data () {
    return {
      routemeta: this.$route.meta,
      coursesColumns: [
        { key: 'id', sortable: true, label: 'ID', tdClass: 'd-none', thClass: 'd-none' },
        { key: 'course_name', sortable: true, label: 'Name' },
        { key: 'status', sortable: true, label: 'Status' },
        { key: 'course_location', sortable: true, label: 'Location' },
        { key: 'course_start', sortable: true, label: 'Start date' },
        { key: 'course_end', sortable: true, label: 'End date' },
        { key: 'progress', sortable: true, label: 'Progress' },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      coursesPerPage: 5,
      courses: [],
      certificatesColumns: [],
      certificatesPerPage: 5,
      certificates: [],
      loading: true
    }
  },
  computed: {
  },
  async created () {
    this.courses_get()
  },
  methods: {
    course_set (id) {
      this.$store.dispatch('currentcourse_id_setcurrent', { course_id: id })
      this.$router.push({ path: '/elearningcourse/' + id })
    },
    async courses_get () {
      this.loading = true
      await this.$store.dispatch('elearning_consultant_getcourses', { consultant_id: this.$store.state.user.id })
        .then(async (resp) => {
          const outCourses = []
          const courses = resp.data.result
          for (let i = 0; i < courses.length; i++) {
            const course =
              {
                ...courses[i],
                progress: courses[i].status === 'Available' ? '' : `${courses[i].modules_done} / ${courses[i].number_modules}`,
                course_start: courses[i].course_start < '1971-01-01' ? '' : courses[i].course_start,
                course_end: courses[i].course_end < '1971-01-01' ? '' : courses[i].course_end
              }
            outCourses.push(course)
          }
          this.courses = outCourses
        })
      this.loading = false
    }
  }
}
</script>
<style scoped>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: var(--line-clamp, 5);
  -webkit-box-orient: vertical;
  word-break: var(--word-break, 'none');
  overflow: hidden;
  hyphens: auto;
  text-align: var(--align, left);
  --is-single-line: 1 - Clamp(0, Calc(var(--line-clamp) - 1), var(--line-clamp));
  --delay: Calc(-1s * (var(--is-single-line, 1) - 1));
  animation: states 1s var(--delay) paused;

  @keyframes states {
      0% { word-break: break-all; }
  }
}
.text-container-wider {
  min-width: 1246px !important;
  margin: 0 auto;
}
</style>
